import React from "react";

const BottomArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="bottom_arrow_icon"
      data-name="bottom arrow"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.59 4.58997L8 9.16997L3.41 4.58997L2 5.99997L8 12L14 5.99997L12.59 4.58997Z"
        fill={props.fill || "#1B252F"}
      />
    </svg>
  );
};

export default BottomArrowIcon;
